import PropTypes from "prop-types"
import Icon from "components/common/Icon"
import styles from "./GuideRatingStars.module.css"

const GuideRatingStars = ({ rating, maxStars = 5, size = 16, className = "" }) => {
  const filledCount = Math.max(0, Math.min(maxStars, Math.round(rating ?? maxStars)))

  return (
    <div className={`hstack gap-1 ${className}`}>
      {new Array(maxStars).fill(null).map((_, index) => (
        <Icon
          key={index}
          iconName="StarNew"
          size={size}
          block
          className={`text-primary-second ${index < filledCount ? "" : styles.emptyStar}`}
        />
      ))}
    </div>
  )
}

GuideRatingStars.propTypes = {
  rating: PropTypes.number,
  maxStars: PropTypes.number,
  size: PropTypes.number,
  className: PropTypes.string
}

export default GuideRatingStars
